import type { FrontendInstaller } from "@p0security/integrations-installer";
import type { SalesforceComponents } from "@p0security/integrations-saas/salesforce/components";
import { Typography } from "@p0security/ui";

const { Paragraph } = Typography;

export const salesforceInstaller: FrontendInstaller<SalesforceComponents> = {
  components: {
    "iam-write": {
      instructions: () => ({
        help: (
          <Paragraph>
            Follow these steps to connect P0 to Salesforce.
            <ol className="preamble-list">
              <li>Create a permission set for P0&apos;s access.</li>
              <li>
                Grant the permission set these permissions: &quot;Assign
                Permission Sets&quot;, &quot;View All Users&quot;.
              </li>
              <li>Create an external client application.</li>
              <li>
                Add the &quot;Manage user data via APIs (api)&quot; scope.
              </li>
              <li>
                Assign the permission set you created to the external client
                application.
              </li>
              <li>Enable the client-credentials flow for the application.</li>
            </ol>
            On the next page you will provide the client&apos;s credentials to
            P0.
          </Paragraph>
        ),
      }),
      items: {},
    },
  },
};
